import type { Ref } from 'react'
import { forwardRef } from 'react'
import 'twin.macro'

import {
  StyledButton,
  LoadingLabel,
  StyledStarSlot,
  StyledEndSlot,
} from './Button.styled'
import type { ButtonProps } from './types'
import { Spinner } from '../Icons'

function Button(
  {
    size = 'medium',
    palette = 'action',
    variation = 'primary',
    fullWidth = false,
    centered = false,
    children,
    isLoading,
    loadingLabel,
    startSlot,
    endSlot,
    ...rest
  }: ButtonProps,
  ref: Ref<HTMLButtonElement>,
) {
  const disabled = Boolean(rest.disabled) || isLoading
  const content = isLoading ? (
    <>
      <Spinner />
      {loadingLabel && <LoadingLabel>{loadingLabel}</LoadingLabel>}
    </>
  ) : (
    // ⚠️ Do not remove the <span> wrapper.
    // We use it to prevent Google Translator issues
    // related to React and DOM reconciliation.
    // https://github.com/facebook/react/issues/11538#issuecomment-417504600
    // https://github.com/facebook/react/issues/11538#issuecomment-390386520
    <span>{children}</span>
  )

  return (
    <StyledButton
      ref={ref}
      size={size}
      palette={palette}
      variation={variation}
      fullWidth={fullWidth}
      centered={centered}
      disabled={disabled}
      startSlot={startSlot}
      endSlot={endSlot}
      {...rest}
    >
      {startSlot && <StyledStarSlot size={size}>{startSlot}</StyledStarSlot>}
      {content}
      {endSlot && <StyledEndSlot size={size}>{endSlot}</StyledEndSlot>}
    </StyledButton>
  )
}

export default forwardRef<HTMLButtonElement, ButtonProps>(Button)
